// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import VueRouter from 'vue-router'
import ElementUI from 'element-ui'
import axios from 'axios'
import 'element-ui/lib/theme-chalk/index.css'
import './assets/css/reset.css'
import './assets/css/amount.css'
import './assets/css/nprogress-custom.css';
import drag from './utils/elDrag'
import vueDrag from './utils/vueDrag'
import directive from "./utils/directive";
import * as echarts from 'echarts'
import {handleTree} from "@/utils/tool";
Vue.prototype.handleTree = handleTree;
import i18n from "./utils/i18n";
import '@/assets/iconfont/iconfont.css'

Vue.config.productionTip = false
Vue.prototype.axios = axios;
axios.defaults.withCredentials = true;

Vue.prototype.echarts = echarts;
Vue.use(ElementUI);

import localStorageProxy from "./utils/listenToStorage";

Vue.prototype.$localStorage = localStorageProxy; // 将代理对象挂载到 Vue 原型上


import VueWechatTitle from 'vue-wechat-title'
Vue.use(VueWechatTitle)

const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}

import store from './store'

import './permission.js';

import '@/assets/css/transition.css';
import 'core-js/features/promise/all-settled';

import CommonModal from "./components/commonModal";
Vue.component('CommonModal', CommonModal);

// json编辑器
import Editor from 'bin-ace-editor';
// 按需引入需要的语言包皮肤等资源
require('brace/mode/json')
require('brace/theme/chrome')
Vue.component(Editor.name, Editor)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  i18n,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js